import { createContext, useContext } from "react";

/**
 * True while a board shows more than one project; its cards then name their
 * project (`TaskProjectChip`).
 */
export const BoardProjectsContext = createContext(false);

export const useBoardShowsProjects = () => useContext(BoardProjectsContext);
